<template>
  <svg data-testid="InfoIcon" width="24px" height="24px" viewBox="0 0 24 24">
    <desc>Info Icon</desc>
    <g stroke="none" stroke-width="1" fill-rule="evenodd">
      <g transform="translate(-176.000000, -116.000000)">
        <g transform="translate(176.000000, 116.000000)">
          <path
            d="M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,
            2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M12,
            24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 C18.627417,
            0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 Z"
            id="circle"
            fill-rule="nonzero"></path>
          <path
            d="M11.5020119,9.56826934 C12.3292904,9.37951528 12.7672247,9.29230219 13.1092246,
            9.29915464 C14.0529949,9.31846611 13.8225032,10.1177118 13.5608639,
            11.3779411 C13.1515853,13.3427275 12.3373888,17.1321365 12.3373888,
            17.1321365 C12.2053232,17.6666281 12.9242083,17.5302019 13.2307,17.3632512 C13.571454,
            17.1782348 13.7458802,17.2959725 13.8000769,17.3881692 C13.8997491,
            17.5744314 13.7122409,17.9675133 13.2120115,18.3369231 C12.5012248,
            18.8626934 11.4079463,19.0408573 10.8603727,19.0315131 C10.3669958,
            19.0227918 10.0791926,18.9492836 9.87361883,18.7437099 C9.70915985,
            18.5792509 9.44627466,18.2983001 9.62693036,17.428038 C9.67738936,
            17.1832184 10.9992907,11.1524329 10.9992907,11.1524329 C11.0360448,
            10.9848592 11.1500448,10.6578101 10.7987006,10.658433 C10.4081105,
            10.6764986 9.99696306,10.7743018 9.69420903,10.5967609 C9.59640578,
            10.5394494 9.46496318,10.3774823 9.52040579,10.22922 C9.61260249,
            9.98128563 11.1388317,9.65112178 11.5020119,9.56826934"
            ></path>
          <path
            d="M14.503326,6.37919793 C14.503326,5.57185385 13.8486048,4.91650974 13.0412607,
            4.91650974 C12.2332937,4.91650974 11.5785725,5.57185385 11.5785725,
            6.37919793 C11.5785725,7.18654201 12.2332937,7.84126317 13.0412607,
            7.84126317 C13.8486048,7.84126317 14.503326,7.18654201 14.503326,6.37919793"
            ></path>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconInfo',
};
</script>

<style scoped>

</style>
